/**
 * EL NOMBRE DEL PRODUCTO, en un solo sitio.
 *
 * Salió de un dictado y falta que Esteban confirme cómo se escribe. Si cambia, se cambia
 * aquí (y el `<title>` de `index.html`) y sale en el acceso, el menú y los textos de ayuda.
 * El nombre del NEGOCIO no va aquí: ese llega del servidor (`INSTALLATION_NAME`).
 */
export const PRODUCTO = 'El Closecito de Andrés';
